export const MAZDA_CLAIM_SERVICE_CODE = 'MAZDA_PORTAL-CLAIM';
